import { render, staticRenderFns } from "./HomePC.vue?vue&type=template&id=68c17e78&scoped=true"
import script from "./HomePC.vue?vue&type=script&lang=js"
export * from "./HomePC.vue?vue&type=script&lang=js"
import style0 from "./HomePC.vue?vue&type=style&index=0&id=68c17e78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c17e78",
  null
  
)

export default component.exports